import React from "react";
import "./Blockchain.css";
import { NavLink } from "react-router-dom";
import { FiArrowRight, FiShield, FiCpu, FiGlobe } from "react-icons/fi";

const BlockChainPage = () => {
  return (
    <div className="sub-service-page">
      <div className="page-bg-engine">
        <div className="theme-orb orb-primary"></div>
        <div className="theme-orb orb-secondary"></div>
      </div>

      {/* --- Section 1: Sovereign Hero --- */}
      <section className="sub-hero">
        <div className="v2-container">
          <div className="sub-hero-content">
            <div className="v3-badge">Web3 Ecosystems</div>
            <h1 className="title-reveal">
              Architecting <span className="blue-glow">Decentralized</span>{" "}
              Futures
            </h1>
            <p className="v3-hero-p-centered">
              We pioneer blockchain solutions that redefine transparency and
              security. Our expert lab builds high-performance protocols and
              scalable dApps for the next human decade.
            </p>
          </div>
        </div>
      </section>

      {/* --- Section 2: Intro Content --- */}
      <section className="sub-content-section">
        <div className="v2-container">
          <div className="content-layout-left">
            <h2 className="v3-title">
              Transforming <span className="blue-glow">Commerce</span>
            </h2>
            <p className="v3-p-text">
              Embrace blockchain development services to transform your
              business. Blockchain is a secure, transparent, & decentralized
              technology that can streamline your business processes and enhance
              customer trust.
            </p>

            <div className="tech-stack-strip">
              <img
                src="https://logowik.com/content/uploads/images/polygon-matic-icon3725.logowik.com.webp"
                alt="Polygon"
              />
              <img src="/block6.svg" alt="Ethereum" />
              <img src="/block7.svg" alt="Binance" />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 3: Feature Boxes --- */}
      <section className="sub-features-section">
        <div className="v2-container">
          <div className="feature-grid-sub">
            <div className="feature-card-sub">
              <div className="f-icon-box">
                <FiCpu />
              </div>
              <h3>Build Your Blockchain</h3>
              <p>
                From architecture and design to implementation and deployment,
                our team can develop every aspect of a blockchain system.
              </p>
              <img
                src="/blockchainlaptop.png"
                alt="Hardware"
                className="f-img-hove"
              />
            </div>

            <div className="feature-card-sub">
              <div className="f-icon-box">
                <FiGlobe />
              </div>
              <h3>Matic Development</h3>
              <p>
                Get greater trust and transparency with token development.
                Tokens can represent anything from real estate to loyalty
                points.
              </p>
              <img
                src="/blockchainlaptop1.png"
                alt="Matic"
                className="f-img-hove"
              />
            </div>

            <div className="feature-card-sub">
              <div className="f-icon-box">
                <FiShield />
              </div>
              <h3>Wallet Development</h3>
              <p>
                Create user-friendly blockchain wallets with the latest security
                standards to safely exchange digital assets.
              </p>
              <img
                src="/blockchainlaptop3.png"
                alt="Wallet"
                className="f-img-hove"
              />
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 4: Platform Detailed info --- */}
      <section className="sub-platforms">
        <div className="v2-container">
          {[
            {
              id: "polygon",
              title: "Polygon",
              desc: "Harness the power of this secure cross-chain platform to build decentralized applications with ease.",
              img: "/matic.png",
            },
            {
              id: "ethereum",
              title: "Ethereum",
              desc: "Empower your development of smart contracts and dApps with unparalleled autonomy and security.",
              img: "/ethereum.png",
              reverse: true,
            },
            {
              id: "binance",
              title: "Binance Smart Chain",
              desc: "Experience rapid transaction speeds and cost-effective fees for DeFi applications and smart contracts.",
              img: "/binance.webp",
            },
          ].map((p, idx) => (
            <div
              className={`platform-row ${p.reverse ? "reverse" : ""}`}
              key={idx}
            >
              <div className="platform-text">
                <h2 className="v3-title">{p.title}</h2>
                <p className="v3-p-text">{p.desc}</p>
                <NavLink to="/contactus" className="btn-secondary">
                  Inquire Now <FiArrowRight />
                </NavLink>
              </div>
              <div className="platform-visual">
                <img src={p.img} alt={p.title} />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* --- Section 5: Universal CTA --- */}
      <section className="v3-final-cta">
        <div className="v2-container">
          <div className="v3-cta-card">
            <div className="v3-cta-content">
              <h2 className="v3-cta-title">
                Ready to launch <br />
                <span className="grad-blue">your protocol?</span>
              </h2>
              <NavLink to="/contactus" className="v3-main-btn">
                <span>Initialize Project</span>
                <div className="btn-icon-box">
                  <FiArrowRight />
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlockChainPage;
